import { $http, buildHeaders } from "./index";

//获取验证码
export const getcaptcha = () => {
  return $http.get("/employee/Login/captcha", {
    headers: {
      unAuth: true,
    },
  });
};

//登录验证
export const judgeLogin = (data) => {
  return $http.post("/employee/Login/doLogin", data, {
    headers: {
      ...buildHeaders(3, "正在验证登录信息，请稍后……"),
      unAuth: true,
    },
  });
};

//获取登录用户信息
export const get_loginuser = () => {
  return $http.get("/employee/Employee/info");
};

//获取带确认工资条
export const salary_list = (params) => {
  return $http.get("/employee/Salary/list", {
    params,
  });
};

//获取发薪申请单详情
export const salary_detail = (id) => {
  return $http.get("/employee/Salary/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//提交审批
export const salary_confirm = (id) => {
  return $http.post(
    "/employee/Salary/confirm",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取档案信息
export const self_info = () => {
  return $http.get("/employee/Index/info", {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取档案信息
export const self_data_select = () => {
  return $http.get("/admin/Data/employeeInfo");
};

//获取行政区划树
export const self_area_tree = () => {
  return $http.get("/admin/AreaCode/index", { params: { limit: 0, tree: 1 } });
};

//上传附件
export const attachment_upload = (data) => {
  let headers = buildHeaders(1, "文件解析中，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/employee/Attachment/upload", data, {
    headers,
  });
};

//保存档案信息
export const self_save = (data) => {
  return $http.post("/employee/Index/save", data, {
    headers: buildHeaders(3),
  });
};

//登出
export const loginout = (params) => {
  return $http.get("/leader/Login/logout", {
    params,
    headers: buildHeaders(3, "登出中，请稍后……"),
  });
};
